import { request } from "../services/request";
import * as ServiceUser from "../services/user";
import * as ServiceGeneric from "../services/generic";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    loading: false,
    authenticated: false,
    bearer: null,
    username: null,
    user: null,
    paymentList: [],
    paymentCustomer: "1",
    availableCountries: [],
    language: "pl",
  },
  mutations: {
    setPaymentList(state, payments) {
      state.paymentList = payments;
    },
    setUsername(state, username) {
      state.username = username;
    },
    setAuthenticated(state, header) {
      state.bearer = header;
      state.authenticated = true;
    },
    clearAuthentication(state) {
      state.authenticated = false;
      state.bearer = null;
      state.username = null;
      state.user = null;
      state.paymentCustomer = "1";
    },
    setLoading(state, value) {
      state.loading = value;
    },

    setUser(state, user) {
      state.user = user;
    },
    setPaymentCustomer(state, value) {
      state.paymentCustomer = value;
    },
    setAvailableCountries(state, value) {
      state.availableCountries = value;
    },
    setLanguage(state, value) {
      state.language = value;
    },
  },
  getters: {
    language: (state) => state.language,
    user: (state) => state.user,
    paymentCustomer: (state) => state.paymentCustomer,
    paymentList: (state) => state.paymentList,
    availableCountries: (state) => state.availableCountries,
  },
  actions: {
    async getUser({ commit, state }) {
      return new Promise((resolve, reject) => {
        let username = state.username;
        ServiceUser.getUserInfo(username)
          .then((resp) => {
            if (resp.data) {
              commit("setUser", resp.data.userCollection.allUserData[0]);
              commit(
                "setAvailableCountries",
                resp.data.userCollection.allUserData[0].additional
              );
              //store.commit('currency/setCurrencyEUR', resp.data.userCollection.allUserData[0].currency[0].value);
              //store.commit('currency/setCurrencyUSD', resp.data.userCollection.allUserData[0].currency[1].value);
            } else {
              console.log(resp);
            }
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getPayment({ commit }) {
      let response = await ServiceGeneric.getPaymentList();
      if (response.data) {
        commit("setPaymentList", response.data.reportFormSubmit.allReports);
      } else {
        console.log(response);
      }
      return response.data.reportFormSubmit.allReports;
    },
    async Logout(context) {
      context.commit("clearAuthentication");
      store.commit("customers/setCustomer", []);
      store.commit("cart/setCleanCart", []);
      store.commit("cart/setCartData", []);
    },
    async Authenticate({ commit }, credentials) {
      const ob = {
        username: credentials.username,
        password: credentials.password,
      };
      commit("setUsername", credentials.username);
      commit("setLoading", true);
      try {
        let res = await request("post", {
          url: process.env.VUE_APP_API_URL.concat(
            "/rest/all/V1/integration/admin/token"
          ),
          params: ob,
        });
        commit("setUsername", credentials.username);
        commit("setAuthenticated", res.data);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
